// Lo que la hoja de ruta le pide al navegador: imprimir, copiar y compartir.
// La vista habla con esto y no con `window` ni `navigator`: en los tests se
// reemplaza por un doble y en la app por `browserRouteSheetActions`.
//
// Nada de esto manda datos a UCORP ni a un tercero: el texto queda en el
// portapapeles o en la hoja de compartir del sistema, y la persona elige.

export interface RouteSheetActions {
  /** Imprime solo la hoja que se le pasa, no el resto del portal. */
  print(sheet: HTMLElement): void;
  copy(text: string): Promise<void>;
  /** Ausente si el navegador no tiene Web Share: la vista no ofrece el boton. */
  share?: (data: { title: string; text: string }) => Promise<void>;
}

/** Clase en <html> mientras se imprime una hoja (route-sheet.css). */
export const PRINTING_CLASS = "hoja-imprimiendo";
/** Marca de la hoja que se imprime: con varias abiertas, sale solo esa. */
export const PRINT_TARGET_ATTRIBUTE = "data-hoja-imprimir";

export function browserRouteSheetActions(): RouteSheetActions {
  const nav: Navigator | undefined = typeof navigator === "undefined" ? undefined : navigator;
  const actions: RouteSheetActions = {
    print(sheet) {
      const root = document.documentElement;
      sheet.setAttribute(PRINT_TARGET_ATTRIBUTE, "");
      root.classList.add(PRINTING_CLASS);
      const done = (): void => {
        sheet.removeAttribute(PRINT_TARGET_ATTRIBUTE);
        root.classList.remove(PRINTING_CLASS);
      };
      // window.print bloquea en la mayoria de los navegadores; afterprint cubre
      // a los que vuelven antes de que se cierre el dialogo.
      window.addEventListener("afterprint", done, { once: true });
      window.print();
    },
    async copy(text) {
      if (nav?.clipboard === undefined) throw new Error("clipboard_unavailable");
      await nav.clipboard.writeText(text);
    },
  };
  if (nav !== undefined && typeof nav.share === "function") {
    actions.share = async (data) => {
      await nav.share(data);
    };
  }
  return actions;
}
